import React from 'react';
import { motion } from 'framer-motion';
interface LogoProps {
  className?: string;
  variant?: 'light' | 'dark';
  size?: 'sm' | 'md' | 'lg' | 'xl';
}
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/6581a4QoG6rfu16awK8g8h/Logo.png';
export function Logo({
  className = '',
  variant = 'dark',
  size = 'md'
}: LogoProps) {
  const sizeClasses = {
    sm: 'h-12',
    md: 'h-14',
    lg: 'h-20',
    xl: 'h-24 md:h-32'
  };
  // On dark backgrounds, the green logo is naturally visible
  // On light backgrounds, it's also visible (green on white)
  // Add a subtle brightness boost for dark variant to make it pop
  const filterClass = variant === 'light' ? 'brightness-110' : '';
  return <motion.div className={`flex items-center ${className}`} initial={{
    opacity: 0,
    scale: 0.9
  }} animate={{
    opacity: 1,
    scale: 1
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} data-id="element-259">
      <img src={LOGO_URL} alt="INTIGOO!" className={`${sizeClasses[size]} w-auto object-contain ${filterClass}`} data-id="element-260" />
    </motion.div>;
}